import { FolderModel } from "./../../../../../../../core/ek-e-commerce/ek-models/folder.model";
import { FoldersService } from "./../../../../../../../core/ek-e-commerce/ek-services/folders.service";
import { CreditModel } from "./../../../../../../../core/ek-e-commerce/ek-models/credit.model";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import fontkit from "@pdf-lib/fontkit";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { ToWords } from "to-words";
import { DocumentModel } from "../../../../../../../core/ek-e-commerce/ek-models/document.model";
import { OrderSplitService } from "../../../../../../../core/ek-e-commerce/ek-services/order-split.service";
import { ClientModel } from "./../../../../../../../core/ek-e-commerce/ek-models/client.model";
import { ocrInfo } from "./../../../../../../../core/ek-e-commerce/ek-models/document-ocr-information";
import { OrderSplit } from "./../../../../../../../core/ek-e-commerce/ek-models/orderSplit";
import { DocumentService } from "./../../../../../../../core/services/document.service";
import { BehaviorSubject } from "rxjs";
import { DatePipe } from "@angular/common";
import { OrderItemModel } from "../../../../../../../core/ek-e-commerce/ek-models/OrderItem.model";
import { ProfessionTranslatePipe } from "../../../../../../../core/_base/layout/pipes/profession-translate.pipe";
import { JiraModel } from "../../../../../../../core/ek-e-commerce/ek-models/jira.model";
import { EkCategoriesService } from "../../../../../../../core/ek-e-commerce/ek-services/ek-categories.service";
import { EkProductsService } from "../../../../../../../core/ek-e-commerce/ek-services/ek-product.service";
import { NumberToArabicService } from "../../../../../../../core/ek-e-commerce/ek-services/numberToArabic.service";
import {
  LayoutUtilsService,
  MessageType,
} from "../../../../../../../core/_base/crud";

@Component({
  selector: "kt-folder-step-six",
  templateUrl: "./folder-step-six.component.html",
  styleUrls: ["./folder-step-six.component.scss"],
  providers: [DatePipe, ProfessionTranslatePipe],
})
export class FolderStepSixComponent implements OnInit {
  @Input() information!: ocrInfo;
  @Input() client!: ClientModel;
  @Input() order!: OrderSplit;
  @Input() folder!: FolderModel;
  @Input() requestNumber: string;

  guaranteesLength = 0;

  orderSplit: OrderSplit;
  loading: boolean;
  checkAccountAgreement: any;
  financingAgreement: any;
  salesContract: any;
  math = Math;
  credit: CreditModel;
  orderId: number;
  folderId: number;
  categories: OrderItemModel[] = [];
  notificationDate: Date;

  guaranteesDocuments$ = new BehaviorSubject<DocumentModel[]>(null);
  invoicessDocuments$ = new BehaviorSubject<DocumentModel[]>(null);

  downLoadFiles$ = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.downLoadFiles$.asObservable();

  ticketToOrder: any;
  currentRole: string = "";
  canDownload: boolean;
  categoriesList: string[];

  jira!: JiraModel;
  arabicDate: string = "";
  normalDate: string = "";

  constructor(
    private documentService: DocumentService,
    private orderService: OrderSplitService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    public folderService: FoldersService,
    private professionTranslatePipe: ProfessionTranslatePipe,
    private categoryService: EkCategoriesService,
    private layoutUtilsService: LayoutUtilsService,
    private productsService: EkProductsService,
    private numberToArabicService: NumberToArabicService,
  ) {
    this.currentRole = JSON.parse(localStorage.getItem("currentUser")).roles;
  }

  async createPdf() {
    this.loading = true;
    this.downLoadFiles$.next(true);

    const toWords = new ToWords({
      localeCode: "fr-FR",
      converterOptions: {
        currency: true,
        ignoreDecimal: false,
        currencyOptions: {
          name: "Dinar",
          plural: "Dinars",
          symbol: "",
          fractionalUnit: {
            name: "Centime",
            plural: "Centimes",
            symbol: "",
          },
        },
      },
    });
    let totalToWords = toWords.convert(
      this.jira?.mtRmb ? this.jira?.mtRmb : this.credit?.reimbursementAmount,
    );

    const myDate = new Date();
    const datePipe = new DatePipe("en-US");
    const formattedDate = datePipe.transform(myDate, "dd/MM/yyyy");

    const url =
      "https://ekiclik-docs.s3.eu-west-2.amazonaws.com/NotoSansArabic-Black.ttf";
    const fontBytes = await fetch(url).then((res) => res.arrayBuffer());

    // ticket To Order ( Saftadja ) -----------------------------------------------------------------------------------------------------------------------------

    if (this.ticketToOrder) {
      const ticketToOrder = await fetch(this.ticketToOrder).then((res) =>
        res.arrayBuffer(),
      );

      const TOR = await PDFDocument.load(ticketToOrder);
      TOR.registerFontkit(fontkit);
      const arabicFont = await TOR.embedFont(fontBytes);
      const helveticaFont = await TOR.embedFont(StandardFonts.HelveticaBold);

      const TORpages = TOR.getPages();
      const TORfirstPage = TORpages[0];

      // request number
      TORfirstPage.drawText(`${this.requestNumber}`, {
        x: 50,
        y: 520,
        size: 12,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // name
      TORfirstPage.drawText(
        `${
          this.information?.personnelInformation?.firstName + "  "
            ? this.information?.personnelInformation?.firstName!
            : ""
        }     ${
          this.information?.personnelInformation?.lastName
            ? this.information?.personnelInformation?.lastName
            : ""
        }`,
        {
          x: 290,
          y: 270,
          size: 8,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      const addressText = `${this.information?.personnelSituation?.personnelSituationAddressAscii}`;
      const maxWidth = 265;
      const fontSize = 8;
      const lineHeight = 15;
      const startX = 290.5;
      let currentY = 250;

      const lines = this.wrapText(
        addressText,
        helveticaFont,
        fontSize,
        maxWidth,
      );

      lines.forEach((line) => {
        TORfirstPage.drawText(line, {
          x: startX,
          y: currentY,
          size: fontSize,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        });
        currentY -= lineHeight;
      });

      // date
      const [day, month, year] = this.normalDate.split("/").map(Number);
      TORfirstPage.drawText(`${day} / ${month} / ${year}`, {
        x: 397,
        y: 198,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // montant
      TORfirstPage.drawText(
        `${
          this.jira?.mtRmb
            ? this.addSeparation(Math.round(100 * this.jira.mtRmb) / 100)
            : this.order.total
              ? this.addSeparation(Math.round(100 * this.order?.total) / 100)
              : ""
        }`,
        {
          x: 660,
          y: 390,
          size: 12,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      // montant currancy
      TORfirstPage.drawText(` دج`, {
        x: 630,
        y: 390,
        size: 8,
        font: arabicFont,
        color: rgb(0, 0, 0),
      });

      // montant in arabic
      const totalToArabicWords = this.numberToArabicService.amountToArabic(
        this.jira?.mtRmb ? this.jira?.mtRmb : this.credit?.reimbursementAmount,
      );
      const amountArabicText = `${totalToArabicWords ? totalToArabicWords : ""}`;
      const maxArabicWidthM = 520;
      const fontArabicSizeM = 8;
      const lineArabicHeightM = 12;
      const startArabicXM = 150;
      let currentArabicYM = 380;

      if (amountArabicText) {
        const arabicLines = this.wrapText(
          amountArabicText,
          arabicFont,
          fontSize,
          maxArabicWidthM,
        );

        arabicLines.forEach((line) => {
          TORfirstPage.drawText(line, {
            x: startArabicXM,
            y: currentArabicYM,
            size: fontArabicSizeM,
            font: arabicFont,
            color: rgb(0, 0, 0),
          });
          currentArabicYM -= lineArabicHeightM;
        });
      }

      // montant en lettres
      const amountText = `${totalToWords ? totalToWords : ""}`;
      const maxWidthM = 450;
      const fontSizeM = 10;
      const lineHeightM = 12;
      const startXM = 100;
      let currentYM = 362;

      if (amountText) {
        const lines = this.wrapText(
          amountText,
          helveticaFont,
          fontSize,
          maxWidthM,
        );

        lines.forEach((line) => {
          TORfirstPage.drawText(line, {
            x: startXM,
            y: currentYM,
            size: fontSizeM,
            font: helveticaFont,
            color: rgb(0, 0, 0),
          });
          currentYM -= lineHeightM;
        });
      }

      TORfirstPage.drawText(
        `${this.jira?.cpt ? "0380 " + this.jira?.cptAgence + this.jira?.cpt : ""}`,
        {
          x: 107.96,
          y: 295,
          size: 10,
          font: helveticaFont,
          color: rgb(0, 0, 0),
        },
      );

      TORfirstPage.drawText(`${this.jira?.cptAgence}`, {
        x: 140.48,
        y: 270.59,
        size: 10,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      TORfirstPage.drawText(`${this.jira?.cptAgence}`, {
        x: 140.48,
        y: 250.72,
        size: 10,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      TORfirstPage.drawText(`${"0380160109999992273"}`, {
        x: 90,
        y: 210,
        size: 10,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      // numero compte agency
      TORfirstPage.drawText(`${this.jira?.cptAgence}`, {
        x: 290,
        y: 130,
        size: 10,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      //  agency manager
      TORfirstPage.drawText(`${this.jira?.cptAgenceResp}`, {
        x: 450,
        y: 110,
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });

      const pdfBytes1 = await TOR.save();
      this.saveByteArray(
        `lettre de change - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes1,
      );
    }

    // Convention de compte de cheque --------------------------------------------------

    if (this.checkAccountAgreement) {
      const checkAccountAgreement = await fetch(
        this.checkAccountAgreement,
      ).then((res) => res.arrayBuffer());

      const CCA = await PDFDocument.load(checkAccountAgreement);
      CCA.registerFontkit(fontkit);
      const arabicFont2 = await CCA.embedFont(fontBytes);
      const helveticaFont2 = await CCA.embedFont(StandardFonts.HelveticaBold);

      const CCApages = CCA.getPages();
      const CCAfirstPage = CCApages[0];
      const CCAsecondPage = CCApages[1];
      const CCAthirdPage = CCApages[2];
      const CCAfourthPage = CCApages[3];

      CCAfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 43,
          y: 820,
          size: 12,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );
      CCAsecondPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 43,
          y: 820,
          size: 12,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );
      CCAthirdPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 43,
          y: 820,
          size: 12,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );
      CCAfourthPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 43,
          y: 800,
          size: 12,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );
      CCAfirstPage.drawText(
        `${this.jira?.cptAgenceResp ? this.jira?.cptAgenceResp : ""}`,
        {
          x: 90,
          y: 698,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );
      CCAfirstPage.drawText(`Directeur d’Agence`, {
        x: 120,
        y: 690,
        size: 7,
        font: helveticaFont2,
        color: rgb(0, 0, 0),
      });

      CCAfirstPage.drawText(`مدير وكالة`, {
        x: 500,
        y: 684,
        size: 7,
        font: arabicFont2,
        color: rgb(0, 0, 0),
      });

      CCAfirstPage.drawText(
        `${this.information?.personnelInformation?.firstName!}     ${
          this.information?.personnelInformation?.lastName
        }`,
        {
          x: 120,
          y: 650,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );
      CCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab
            : ""!
        } ${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: 450,
          y: 650,
          size: 7,
          font: arabicFont2,
          color: rgb(0, 0, 0),
        },
      );

      // left side

      CCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: 130,
          y: 632,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.placeOfBirth
            ? this.information?.personnelInformation?.placeOfBirth
            : ""
        }`,
        {
          x: 200,
          y: 632,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      // right side

      CCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: 470,
          y: 639,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfirstPage.drawText(
        `${
          this.information?.personnelInformation?.placeOfBrithArabic
            ? this.information?.personnelInformation?.placeOfBrithArabic
            : ""
        }`,
        {
          x: this.getX(
            460,
            this.information?.personnelInformation?.placeOfBrithArabic,
            arabicFont2,
            9,
          ),
          y: 639,
          size: 7,
          font: arabicFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddress
            ? this.invertNumbers(
                this.information?.personnelSituation
                  ?.personnelSituationAddress!,
              )
            : ""
        }`,
        {
          x: this.getX(
            540,
            String(
              this.information?.personnelSituation?.personnelSituationAddress,
            ),
            arabicFont2,
            7,
          ),
          y: 613,
          size: 7,
          font: arabicFont2,
          color: rgb(0, 0, 0),
        },
      );

      // left

      CCAfirstPage.drawText(
        `${
          this.information?.professionalSituation?.profession
            ? this.professionTranslatePipe.transform(
                this.information?.professionalSituation?.profession,
              )
            : ""
        }`,
        {
          x: 90,
          y: 624,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddressAscii
            ? this.information?.personnelSituation
                ?.personnelSituationAddressAscii
            : ""
        }`,
        {
          x: 80,
          y: 608,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      //French
      CCAfourthPage.drawText(
        `${
          this.order.pointOfSaleTo?.posCommune
            ? this.order.pointOfSaleTo?.posCommune
            : ""
        }`,
        {
          x: 80,
          y: 613,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfourthPage.drawText(`${this.normalDate}`, {
        x: 160,
        y: 613,
        size: 7,
        font: helveticaFont2,
        color: rgb(0, 0, 0),
      });

      CCAfourthPage.drawText(
        `${this.jira?.cptAgence ? this.jira?.cptAgence : ""}`,
        {
          x: 170,
          y: 508,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfourthPage.drawText(`${this.jira?.cpt ? this.jira?.cpt : ""}`, {
        x: 170,
        y: 496,
        size: 7,
        font: helveticaFont2,
        color: rgb(0, 0, 0),
      });

      CCAfourthPage.drawText(`DZD`, {
        x: 170,
        y: 485,
        size: 7,
        font: helveticaFont2,
        color: rgb(0, 0, 0),
      });

      // Arabic

      CCAfourthPage.drawText(
        `${
          this.order.pointOfSaleTo?.posCommune
            ? this.order.pointOfSaleTo?.posCommune
            : ""
        }`,
        {
          x: 510,
          y: 613,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfourthPage.drawText(`${this.arabicDate}`, {
        x: 443,
        y: 613,
        size: 7,
        font: helveticaFont2,
        color: rgb(0, 0, 0),
      });

      CCAfourthPage.drawText(
        `${this.jira?.cptAgence ? this.jira?.cptAgence : ""}`,
        {
          x: 380,
          y: 508,
          size: 7,
          font: helveticaFont2,
          color: rgb(0, 0, 0),
        },
      );

      CCAfourthPage.drawText(`${this.jira?.cpt ? this.jira?.cpt : ""}`, {
        x: 380,
        y: 496,
        size: 7,
        font: helveticaFont2,
        color: rgb(0, 0, 0),
      });

      CCAfourthPage.drawText(`دج`, {
        x: 400,
        y: 485,
        size: 7,
        font: arabicFont2,
        color: rgb(0, 0, 0),
      });

      // const date = new Date();
      // const dateString = date.toLocaleDateString();

      const pdfBytes2 = await CCA.save();
      this.saveByteArray(
        `Convention de compte de cheque - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes2,
      );
    }

    // Convention de financement --------------------------------------------------
    if (this.financingAgreement) {
      const ConvensionDeFinancement = await fetch(this.financingAgreement).then(
        (res) => res.arrayBuffer(),
      );

      const CDF = await PDFDocument.load(ConvensionDeFinancement);
      CDF.registerFontkit(fontkit);
      const arabicFont3 = await CDF.embedFont(fontBytes);
      const helveticaFont3 = await CDF.embedFont(StandardFonts.HelveticaBold);

      const CDFpages = CDF.getPages();
      const CDFZeroPage = CDFpages[0];
      const CDFfirstPage = CDFpages[1];
      //const CDFthirdPage = CDFpages[2];

      CDFZeroPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 37,
          y: 800,
          size: 12,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );
      CDFfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 37,
          y: 800,
          size: 12,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      CDFZeroPage.drawText(`${this.arabicDate}`, {
        x: 80,
        y: 137,
        size: 10,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      CDFfirstPage.drawText(
        `${this.jira?.cptAgenceResp ? this.jira?.cptAgenceResp : " "}`,
        {
          x: 280,
          y: 690,
          size: 9,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );
      CDFfirstPage.drawText(
        `${this.jira?.cptAgence ? this.jira?.cptAgence : ""}`,
        {
          x: 180,
          y: 690,
          size: 9,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      CDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab
            : ""!
        } ${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          x: this.getX(
            460,
            this.information?.personnelInformation?.lastNameEnArab! +
              this.information?.personnelInformation?.fistNameEnArab,
            arabicFont3,
            10,
          ),
          y: 665,
          size: 10,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        },
      );

      CDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.placeOfBrithArabic
            ? this.information?.personnelInformation?.placeOfBrithArabic
            : ""
        }`,
        {
          x: this.getX(
            340,
            this.information?.personnelInformation?.placeOfBrithArabic,
            arabicFont3,
            9,
          ),
          y: 665,
          size: 9,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        },
      );

      CDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: this.getX(
            260,
            this.information?.personnelInformation?.birthDay,
            helveticaFont3,
            9,
          ),
          y: 665,
          size: 9,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      CDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.idCardNumber
            : this.information?.personnelInformation?.driverLicenceNumber
              ? this.information?.personnelInformation?.driverLicenceNumber
              : ""
        }`,
        {
          x: 435,
          y: 653,
          size: 10,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      CDFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.deliveryDate
            : this.information?.personnelInformation?.driverLicenceIssuanceDate
        }`,
        {
          x: 276,
          y: 653,
          size: 10,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );
      CDFfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddress
            ? this.invertNumbers(
                this.information?.personnelSituation
                  ?.personnelSituationAddress!,
              )
            : ""
        }`,
        {
          x: this.getX(
            470,
            String(
              this.information?.personnelSituation?.personnelSituationAddress,
            ),
            arabicFont3,
            9,
          ),
          y: 640,
          size: 10,
          font: arabicFont3,
          color: rgb(0, 0, 0),
        },
      );

      let categoriesList = Array.from(new Set(this.categoriesList));
      categoriesList = categoriesList.map((s) => s.toLowerCase());
      if (categoriesList?.length < 3) {
        const firstLineCategories = categoriesList?.join(", "); // Join the first four categories with commas
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = `${8}px ${helveticaFont3}`;

        const firstLineTextWidth =
          context.measureText(firstLineCategories).width;
        const adjustedXFirstLine = 300 - firstLineTextWidth / 2;

        CDFfirstPage.drawText(firstLineCategories ? firstLineCategories : "", {
          x: adjustedXFirstLine,
          y: 568,
          size: 10,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        });
      } else {
        const firstLineCategories = categoriesList?.slice(0, 2).join(", "); // Join the first four categories with commas
        const remainingCategories = categoriesList?.slice(2).join(", "); // Join the remaining categories with commas

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = `${10}px ${helveticaFont3}`;

        const firstLineTextWidth =
          context.measureText(firstLineCategories).width;
        const secondLineTextWidth =
          context.measureText(remainingCategories).width;
        const adjustedXFirstLine = 310 - firstLineTextWidth / 2;
        const adjustedXSecondLine = 290 - secondLineTextWidth / 2;

        CDFfirstPage.drawText(firstLineCategories ? firstLineCategories : "", {
          x: adjustedXFirstLine,
          y: 568,
          size: 9,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        });
        CDFfirstPage.drawText(remainingCategories ? remainingCategories : "", {
          x: adjustedXSecondLine,
          y: 560,
          size: 9,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        });
      }

      CDFfirstPage.drawText(
        `${
          this.jira?.mtRmb
            ? this.addSeparation(Math.round(100 * this.jira.mtRmb) / 100)
            : this.credit?.reimbursementAmount
              ? this.addSeparation(
                  Math.round(100 * this.credit.reimbursementAmount) / 100,
                )
              : ""
        }`,
        {
          x: 355,
          y: 555,
          size: 9,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );
      CDFfirstPage.drawText(`${totalToWords ? totalToWords : ""}`, {
        x: 70,
        y: 545,
        size: 10,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      CDFfirstPage.drawText(`${" 0,00"}`, {
        x: 210,
        y: 533,
        size: 10,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      CDFfirstPage.drawText(
        `${this.credit.numberOfMonths ? this.credit.numberOfMonths : ""}`,
        {
          x: 230,
          y: 520,
          size: 10,
          font: helveticaFont3,
          color: rgb(0, 0, 0),
        },
      );

      let x = 50;
      let y = 487;
      if (
        this.jira?.conditions &&
        this.jira?.conditions?.includes("\n" || "\r\n" || "\r")
      ) {
        let conditions = this.jira?.conditions?.split(/\r\n|\r|\n/);
        conditions?.forEach((condition, index) => {
          if (condition.trim().split(/\s+/).length >= 12) {
            let firstLine = condition.split(" ").slice(0, 11).join(" ");
            let secondLine = condition.split(" ").slice(11).join(" ");
            CDFfirstPage.drawText(`${index + 1}- ${firstLine.trimLeft()}`, {
              x: x,
              y: y,
              size: 10,
              font: helveticaFont3,
              color: rgb(0, 0, 0),
            });
            y = y - 15;

            CDFfirstPage.drawText(
              `    ${
                secondLine
                //.replace(/(\b\d(?![.,])\b|-)/g, "")
                // .trimLeft()
              }.`,
              {
                x: x,
                y: y,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            y = y - 15;
          } else {
            CDFfirstPage.drawText(
              `${index + 1}- ${
                condition
                //.replace(/(\b\d(?![.,])\b|-)/g, "")
              }.`,
              {
                x: x,
                y: y,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            y = y - 15;
          }
        });

        let guarantees: string[] = [];
        guarantees = this.jira?.guarantees.split(/\r\n|\r|\n/);
        let guaranteesFiltered = guarantees?.filter(
          (guarantee) => guarantee !== " ",
        );
        guaranteesFiltered = guaranteesFiltered?.filter((item) =>
          isNaN(Number(item)),
        );
        let xG = 50;
        let yG = 435;

        guaranteesFiltered?.forEach((guarantee, index) => {
          if (guarantee !== "") {
            if (guarantee.trim().split(/\s+/).length >= 12) {
              let firstLine = guarantee.split(" ").slice(0, 11).join(" ");
              let secondLine = guarantee.split(" ").slice(11).join(" ");
              CDFfirstPage.drawText(`${index + 1}- ${firstLine}`, {
                x: xG,
                y: yG,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              });
              yG = yG - 15;

              CDFfirstPage.drawText(`${secondLine}.`, {
                x: xG,
                y: yG,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              });
              yG = yG - 15;
            } else {
              CDFfirstPage.drawText(`${index + 1}- ${guarantee}.`, {
                x: xG,
                y: yG,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              });
              yG = yG - 15;
            }
          }
        });
      } else {
        let conditions: string[] = [];
        conditions = this.jira?.conditions?.split(/[.-]/);
        let conditionsFiltered = conditions?.filter(
          (condition) => condition !== " ",
        );
        conditionsFiltered = conditionsFiltered?.filter((item) =>
          isNaN(Number(item)),
        );
        conditionsFiltered?.forEach((condition, index) => {
          if (condition !== "") {
            if (condition.trim().split(/\s+/).length >= 12) {
              let firstLine = condition.split(" ").slice(0, 13).join(" ");
              let secondLine = condition.split(" ").slice(13).join(" ");
              CDFfirstPage.drawText(`${index + 1}- ${firstLine}`, {
                x: x,
                y: y,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              });
              y = y - 10;

              CDFfirstPage.drawText(`${secondLine}.`, {
                x: x + 12,
                y: y,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              });
              y = y - 15;
            } else {
              CDFfirstPage.drawText(
                `${index + 1}- ${
                  condition
                  // .replace(/(\b\d(?![.,])\b|-)/g, "")
                }.`,
                {
                  x: x,
                  y: y,
                  size: 10,
                  font: helveticaFont3,
                  color: rgb(0, 0, 0),
                },
              );
              y = y - 15;
            }
          }
        });

        let guarantees: string[] = [];
        guarantees = this.jira?.guarantees.split(/[.-]/);

        let xG = 50;
        let yG = 435;

        let guaranteesFiltered = guarantees?.filter(
          (guarantee) => guarantee !== " ",
        );
        guaranteesFiltered = guaranteesFiltered?.filter((item) =>
          isNaN(Number(item)),
        );
        guaranteesFiltered?.forEach((guarantee, index) => {
          if (guarantee !== "") {
            CDFfirstPage.drawText(
              `${index + 1}- ${guarantee
                .replace(/(\b\d(?![.,])\b|-)/g, "")
                .trimLeft()}.`,
              {
                x: xG,
                y: yG,
                size: 10,
                font: helveticaFont3,
                color: rgb(0, 0, 0),
              },
            );
            yG = yG - 15;
          }
        });
      }
      CDFfirstPage.drawText(`${this.arabicDate}`, {
        x: 360,
        y: 360,
        size: 10,
        font: helveticaFont3,
        color: rgb(0, 0, 0),
      });

      const pdfBytes3 = await CDF.save();
      this.saveByteArray(
        `Convention de financement - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes3,
      );
    }

    // Contrat de vente par facilité --------------------------------------------------

    if (this.salesContract) {
      const salesContract = await fetch(this.salesContract).then((res) =>
        res.arrayBuffer(),
      );

      const CDVF = await PDFDocument.load(salesContract);
      CDVF.registerFontkit(fontkit);
      const arabicFont4 = await CDVF.embedFont(fontBytes);
      const helveticaFont4 = await CDVF.embedFont(StandardFonts.HelveticaBold);

      const CDVFpages = CDVF.getPages();
      const CDVFfirstPage = CDVFpages[0];

      CDVFfirstPage.drawText(
        `${this.folder?.requestNumber ? this.folder?.requestNumber : ""}`,
        {
          x: 40,
          y: 770,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      CDVFfirstPage.drawText(
        `${this.jira?.cptAgenceResp ? this.jira?.cptAgenceResp : ""}`,
        {
          // x: 400,
          x: 380,
          y: 668,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      CDVFfirstPage.drawText(
        `${this.jira?.cptAgence ? this.jira?.cptAgence : ""}`,
        {
          // x: 400,
          x: 280,
          y: 668,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );
      CDVFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.fistNameEnArab
            ? this.information?.personnelInformation?.fistNameEnArab!
            : ""
        }     ${
          this.information?.personnelInformation?.lastNameEnArab
            ? this.information?.personnelInformation?.lastNameEnArab
            : ""
        }`,
        {
          // x: 400,
          x: this.getX(
            450,
            this.information?.personnelInformation?.lastNameEnArab! +
              this.information?.personnelInformation?.fistNameEnArab,
            arabicFont4,
            9,
          ),
          y: 620,
          size: 9,
          font: arabicFont4,
          color: rgb(0, 0, 0),
        },
      );
      CDVFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.placeOfBrithArabic
            ? this.information?.personnelInformation?.placeOfBrithArabic
            : ""
        }`,
        {
          x: this.getX(
            460,
            this.information?.personnelInformation?.placeOfBrithArabic,
            arabicFont4,
            9,
          ),
          y: 605,
          size: 9,
          font: arabicFont4,
          color: rgb(0, 0, 0),
        },
      );
      CDVFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.birthDay
            ? this.information?.personnelInformation?.birthDay
            : ""
        }`,
        {
          x: this.getX(
            320,
            this.information?.personnelInformation?.birthDay,
            helveticaFont4,
            9,
          ),
          y: 605,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      CDVFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.idCardNumber
            : this.information?.personnelInformation?.driverLicenceNumber
              ? this.information?.personnelInformation?.driverLicenceNumber
              : ""
        }`,
        {
          x: this.getX(
            470,
            String(
              this.information?.personnelInformation?.idCardNumber
                ? this.information?.personnelInformation?.idCardNumber
                : this.information?.personnelInformation?.driverLicenceNumber,
            ),
            helveticaFont4,
            7,
          ),
          y: 590,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );
      CDVFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.deliveryDate
            : this.information?.personnelInformation?.driverLicenceIssuanceDate
        }`,
        {
          x: this.getX(
            320,
            String(
              this.information?.personnelInformation?.idCardNumber
                ? this.information?.personnelInformation?.deliveryDate
                : this.information?.personnelInformation
                    ?.driverLicenceIssuanceDate,
            ),
            helveticaFont4,
            9,
          ),
          y: 590,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );
      CDVFfirstPage.drawText(
        `${
          this.information?.personnelInformation?.idCardNumber
            ? this.information?.personnelInformation?.deliveryDaira
            : this.information?.personnelInformation?.issuingAuthorityLatin
        }`,
        {
          x: this.getX(
            200,
            String(
              this.information?.personnelInformation?.idCardNumber
                ? this.information?.personnelInformation?.deliveryDaira
                : this.information?.personnelInformation?.issuingAuthorityLatin,
            ),
            helveticaFont4,
            9,
          ),
          y: 590,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      CDVFfirstPage.drawText(
        `${
          this.information?.personnelSituation?.personnelSituationAddress
            ? this.invertNumbers(
                this.information?.personnelSituation
                  ?.personnelSituationAddress!,
              )
            : ""
        }`,
        {
          x: this.getX(
            455,
            String(
              this.information?.personnelSituation?.personnelSituationAddress,
            ),
            arabicFont4,
            9,
          ),
          y: 574,
          size: 9,
          font: arabicFont4,
          color: rgb(0, 0, 0),
        },
      );

      CDVFfirstPage.drawText(
        `${
          this.jira?.mtRmb
            ? this.addSeparation(Math.round(100 * this.jira.mtRmb) / 100)
            : this.credit?.reimbursementAmount
              ? this.addSeparation(
                  Math.round(100 * this.credit.reimbursementAmount) / 100,
                )
              : ""
        }`,
        {
          x: 370,
          y: 315,
          size: 9,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        },
      );

      const totalWordsTable = totalToWords.split(" ");

      if (totalWordsTable.length > 4) {
        let firstLine = totalWordsTable.slice(0, 6);
        let secondLine = totalWordsTable.slice(6);

        CDVFfirstPage.drawText(`${firstLine ? firstLine.join(" ") : ""}`, {
          x: 325,
          y: 283,
          size: 8,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        });

        CDVFfirstPage.drawText(`${secondLine ? secondLine.join(" ") : ""}`, {
          x: 325,
          y: 275,
          size: 8,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        });
      } else {
        CDVFfirstPage.drawText(`${totalToWords ? totalToWords : ""}`, {
          x: 310,
          y: 283,
          size: 8,
          font: helveticaFont4,
          color: rgb(0, 0, 0),
        });
      }

      // CDVFfirstPage.drawText(
      //     `${
      //         this.jira?.mtRmb
      //             ? this.addSeparation(Math.round(100 * this.jira.mtRmb) / 100)
      //             : this.credit?.reimbursementAmount
      //                 ? this.addSeparation(
      //                     Math.round(100 * this.credit.reimbursementAmount) / 100
      //                 )
      //                 : ''
      //     }`,
      //     {
      //         x: 360,
      //         y: 205,
      //         size: 9,
      //         font: helveticaFont4,
      //         color: rgb(0, 0, 0),
      //     }
      // );

      // CDVFfirstPage.drawText(
      //   `${this.arabicDate}`,
      //   {
      //     x: 220,
      //     y: 236,
      //     size: 10,
      //     font: helveticaFont4,
      //     color: rgb(0, 0, 0),
      //   }
      // );

      const pdfBytes4 = await CDVF.save();
      this.saveByteArray(
        `Contrat de vente par facilité - ${this.folder?.requestNumber ? this.folder?.requestNumber : ""}.pdf`,
        pdfBytes4,
      );
    }

    this.loading = false;
    this.downLoadFiles$.next(false);
  }

  saveByteArray(reportName: any, byte: any) {
    const blob = new Blob([byte], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = reportName;
    link.click();
  }

  addSeparation(value: number): string {
    if (value) {
      const stringValue = value.toString();
      return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      return "";
    }
  }

  downloadInvoices() {
    this.orderService.downloadInvoices(this.orderId, this.requestNumber);
  }

  downloadDocuments() {
    this.downloadInvoices();
    this.downloadFilledGuarantees();
    //this.createPdf();
  }

  sendGuranateesToEtayssir() {
    this.documentService.sendGuaranteesToEtayssir(this.folderId).subscribe({
      next: (res) => {
        const message = `Documents envoyés avec succès`;
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Create,
          5000,
          true,
          true,
        );
      },
      error: (err) => {
        const message = err.error ?? "Erreur dans l’envoi des documents !";
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Delete,
          5000,
          true,
          true,
        );
      },
    });
  }

  sendInvoicesToEtayssir() {
    this.documentService.sendInvoicesToEtayssir(this.folderId).subscribe({
      next: (res) => {
        const message = `Factures envoyées avec succès`;
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Create,
          5000,
          true,
          true,
        );
      },
      error: (err) => {
        const message = err.error ?? "Erreur dans l’envoi des factures !";
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Delete,
          5000,
          true,
          true,
        );
      },
    });
  }

  downloadFilledGuarantees() {
    this.documentService.getFilledGuarantees(this.folderId).subscribe({
      next: (documents) => {
        if (documents) {
          const docsMap: Record<string, string> = documents;

          // Custom names for known documents
          const documentNames: Record<string, string> = {
            TICKET_TO_ORDER: `Lettre_de_change_${this.requestNumber}.pdf`,
            ACCOUNT_OPENING_REQUEST: `Convention_de_compte_de_cheque_${this.requestNumber}.pdf`,
            FINANCING_AGREEMENT: `Convention_de_financement_${this.requestNumber}.pdf`,
            SALES_CONTRACT_BY_FACILITY: `Contrat_de_vente_par_facilite_${this.requestNumber}.pdf`,
          };

          // Automatic download of new document types
          Object.entries(docsMap).forEach(([key, url]) => {
            if (!url) {
              return;
            }
            // use custom names for known documents or Default name for unknown ones
            const fileName =
              documentNames[key] ||
              `${key.toLowerCase()}_${this.requestNumber}.pdf`;

            this.documentService.downloadFile(url, fileName);
          });
        } else {
          const message = `Les documents de garantie n’ont pas encore été transmis par Etaysir.`;

          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Delete,
            5000,
            true,
            true,
          );
        }

        this.downLoadFiles$.next(false);
      },

      error: () => {
        this.downLoadFiles$.next(false);

        const message = `Les documents de garantie n’ont pas encore été transmis par Etaysir.`;

        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Delete,
          5000,
          true,
          true,
        );
      },
    });
  }

  getX(x: number, value: string, font: any, fontSize: number) {
    if (value) {
      const textWidth = font.widthOfTextAtSize(value, fontSize);
      return x - textWidth;
    } else {
      return 0;
    }
  }

  // ChatGPT is for NEWBIES
  addDays(): string {
    if (this.notificationDate) {
      const currentDate = this.notificationDate;
      this.arabicDate = this.datePipe.transform(currentDate, "yyyy/MM/dd");
      this.normalDate = this.datePipe.transform(currentDate, "dd/MM/yyyy");
    } else {
      return;
    }
  }

  invertNumbers(input: string): string {
    return input.replace(/\d+/g, (match) => {
      return match.split("").reverse().join("");
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.orderId = Number(params.get("idOrder"));
      this.folderId = Number(params.get("idFolder"));
    });

    this.getGuarantees();

    this.orderService.orderSplit$.subscribe((res) => {
      if (res) {
        this.orderSplit = res;
        this.categories = this.orderSplit.orderItems;
      }
    });

    this.folderService.folderStateSubj$.subscribe((state) => {
      if (state === "EK_CONTROL_BEFORE_GUARANTEES_PRINTING") {
        this.canDownload =
          this.currentRole === "ROLE_SUPERADMIN" ||
          this.currentRole === "ROLE_ADMIN";
        return;
      }
      this.canDownload =
        state === "EK_GUARTENTEES_PENDING_SIGNATURE" ||
        state === "EK_GUARTENTEES_SIGNED_IN_PROGRESS" ||
        state === "EK_PHYSICAL_FOLDER_PENDING" ||
        state === "EK_PHYSICAL_FOLDER_WAITING_FOR_PICK" ||
        state === "EK_WAITING_FOR_CLIENT" ||
        state === "EK_PHYSICAL_FOLDER_PICKEDUP" ||
        state === "EK_PHYSICAL_FOLDER_IN_DELIVERY" ||
        state === "EK_PHYSICAL_FOLDER_DELIVERED" ||
        state === "EK_PHYSICAL_FOLDER_IN_PROGRESS" ||
        state === "EK_BANK_PHYSICAL_FOLDER_IN_DELIVERY" ||
        state === "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS" ||
        state === "EK_BANK_PHYSICAL_FOLDER_ACCEPTED" ||
        state === "EK_BANK_PHYSICAL_FOLDER_RESERVE" ||
        state === "EK_BANK_REFUSED" ||
        state === "EK_FOLDER_REFUSED" ||
        state === "EK_CLIENT_NO_RESPONSE" ||
        state === "FINANCIAL_FOLDER" ||
        state === "EK_FOLDER_PICKUP_FAILED";
    });

    this.orderService.orderSplit$.subscribe((res) => {
      if (res) {
        this.orderService.getCredit(res.id).subscribe((cr) => {
          this.credit = cr;
        });

        this.folderService.getJiraByFolderId(res.folderId).subscribe({
          next: (jira) => {
            this.jira = jira;
          },
        });

        this.categoriesList = [];

        res.orderItems.forEach((config) => {
          this.productsService
            .getById(config.configurationTO.productId)
            .subscribe((product) => {
              if (product) {
                this.categoryService
                  .getParentCategoryById(product.categoryId)
                  .subscribe((category) => {
                    if (category) {
                      this.categoriesList.push(category);
                    }
                  });
              }
            });
        });
      }
    });

    this.orderService.getCredit(this.orderId).subscribe((cr) => {
      this.credit = cr;
    });

    this.documentService.getNotifDate(this.folderId).subscribe({
      next: (res) => {
        if (res.body) {
          this.notificationDate = new Date(res.body);
          this.addDays();
        }
      },
      error: (err) => {
        console.log("error :", err);
      },
    });
  }

  wrapText(
    text: string,
    font: any,
    fontSize: number,
    maxWidth: number,
  ): string[] {
    const words = text.split(" ");
    const lines: string[] = [];
    let currentLine = "";

    words.forEach((word) => {
      const testLine = currentLine.length > 0 ? currentLine + " " + word : word;
      const width = font.widthOfTextAtSize(testLine, fontSize);

      if (width > maxWidth) {
        if (currentLine.length > 0) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          lines.push(word);
          currentLine = "";
        }
      } else {
        currentLine = testLine;
      }
    });

    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    return lines;
  }

  guaranteesFilled() {
    this.guaranteesLength++;
    this.refreshGuaranteesCount();
  }

  // Pure refresh — no optimistic increment
  refreshGuaranteesCount() {
    this.documentService
      .downloadDocuments("GUARANTEES", this.folderId)
      .subscribe({
        next: (res) => {
          this.guaranteesLength = res.body.length;
        },
      });
  }

  getGuarantees() {
    this.refreshGuaranteesCount();
    this.documentService
      .getDocumentsByFolderId(this.folderId)
      .subscribe((res: any) => {
        this.guaranteesDocuments$.next(
          res.body.filter(
            (document: DocumentModel) =>
              document.documentsType === "GUARANTEES",
          ),
        );
        this.invoicessDocuments$.next(
          res.body.filter(
            (document: DocumentModel) =>
              document.documentsType === "INVOICE" ||
              document.documentsType === "BANK",
          ),
        );
      });
  }

  downloadEmptyDocuments() {
    this.documentService
      .downloadDocuments("GUARANTEES_EMPTY", this.orderId)
      .subscribe({
        next: (res: any) => {
          const obj = res.body.find((o: any) => {
            switch (o.documentsTitle) {
              case "TICKET_TO_ORDER": {
                this.ticketToOrder = o.documentUrl;
                break;
              }
              case "ACCOUNT_OPENING_REQUEST": {
                this.checkAccountAgreement = o.documentUrl;
                break;
              }
              case "FINANCING_AGREEMENT": {
                this.financingAgreement = o.documentUrl;
                break;
              }
              case "SALES_CONTRACT_BY_FACILITY": {
                this.salesContract = o.documentUrl;
                break;
              }
            }
          });
        },
        error: () => {
          this.downLoadFiles$.next(false);
          const message = `Erreur lors du téléchargement des documents guarantes !`;
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Delete,
            5000,
            true,
            true,
          );
        },
      });
  }

  onDeleteDoc(docId: number) {
    this.documentService.deleteDocument(docId).subscribe({
      next: (res) => {
        this.getGuarantees();
        const message = "Document supprimé avec succès";
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Delete,
          5000,
          false,
          false,
        );
      },
      error: (err) => {
        console.error(err);
        const message =
          "Une erreur est survenue lors de la suppression du document";
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Delete,
          5000,
          false,
          false,
        );
      },
    });
  }
}
